/*
 * Copyright (c) 2020.
 * Simon
 */

import React, {Component} from 'react';
import {connect} from "react-redux";

class HearFacebookButtonPayloads extends Component {

    constructor(props) {
        super(props);


        this.state = {
            payloads: [],
        }
    }

    componentDidMount() {
        this.getHearByProps(this.props);
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.getHearByProps(nextProps);
    }

    getHearByProps(props) {
        let hears = props.hears[props.fanpageId];
        let payload = props.payload;
        let payloads = [];

        Object.keys(hears).forEach(function (key) {
            let hearData = hears[key];
            if (hearData['hear'] === payload) {
                payloads.push(hearData);
            }
        });

        this.setState({payloads: payloads});
    };

    render() {
        return (
            <ul className="payloadLevel1">
                {this.state.payloads.map(function (hearData, index1) {
                    let replies = [];
                    let hear = hearData['hear'];
                    let hearId = hearData['hear_id'];

                    if (this.props.button.loopHearExist(hearId)) {
                        return true;
                    }

                    this.props.button.loopHearAdd(hearId);

                    replies.push(<a
                        style={{display:'block'}}
                        href={`/facebook/fanpage/${this.props.fanpageId}/hears/${hearId}`}
                        key={hearId.toString() + index1 + 'link'}
                    >
                        {hearId}: {hear}
                    </a>);

                    let hearReplies = hearData['replies'];
                    hearReplies.map(function (reply, index2) {
                        if (reply.type === 'facebook_button') {
                            let buttons = reply.buttons;
                            if (buttons === undefined) return true;

                            buttons.map(function (button, index3) {

                                if (button.type === 'postback' && this.props.button.loopHears.length < 100) {
                                    replies.push(<HearFacebookButtonPayloads
                                        key={hearId.toString() + index1 + index2 + index3 + button.payload}
                                        fanpageId={this.props.fanpageId}
                                        payload={button.payload}
                                        hears={this.props.hears}
                                        button={this.props.button}
                                    />);
                                }
                            }.bind(this));
                        }

                        return true;
                    }.bind(this));

                    return replies;
                }.bind(this))}
            </ul>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        hears: state.HearsReducer
    }
};

export default connect(mapStateToProps, {})(HearFacebookButtonPayloads);